<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
		<IconTip slot="icontip"></IconTip>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/orderDetail.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrap.vue'
import FiltersBox from '@/components/reportform/orderDetail/FiltersBox.vue'
import IconTip from '@/components/reportform/orderDetail/IconTip.vue'
export default {
	name: 'RorderDetail',
	components: {
		reportFormWrap,
		FiltersBox,
		IconTip
	},
	data () {
		return {
			reportid: 'ORDER_MXDZ_000003',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getOrderDetailReport`,
			orderMenu: orderMenu
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
